export default {
  pt: {
    LOGIN_WITH_FACEBOOK_SING_UP: 'Entrar com Facebook',
    LOGIN_WITH_GOOGLE_SING_UP: 'Entrar com Google',
    LOGIN_WITH_FACEBOOK_SIGN_IN: 'Entrar com Facebook',
    LOGIN_WITH_GOOGLE_SIGN_IN: 'Entrar com Google',
    LOGIN_WITH_MICROSOFT_SIGN_IN: 'Entrar com Microsoft',
    LOGIN_WITH_MICROSOFT_SECURE_AUTH: 'Entrar com SecureAuth',
    LOGIN_WITH_OPENAGORA: 'Entrar com Openagora',

    AUTH_VALIDATION_LEGALS_REQUIRED:
      'Você deve aceitar os Termos, Condições e Políticas para se registrar.',
    INPUT_REQUIRED: 'Campo obrigatório',
    VALIDATE_MAX_PASSWORD: 'Sua senha deve ter no máximo 6 caracteres',
    VALIDATE_MIN_PASSWORD: 'Sua senha deve ter pelo menos 6 caracteres',
    VALIDATE_FORMAT_EMAIL: 'Por favor digite um email válido.',
    PASSWORD_DOES_NOT_MATCH: 'As senhas não correspondem',

    LEGALS_TEXT_1: 'Aceito os ',
    LEGALS_TEXT_2: 'Termos, Condições e Políticas de Crehana.',

    CONTINUE_WITH: 'Continue com:',

    SENDING: 'Enviando...',
    GENERIC_ERROR: 'Ocorreu um erro. Tente novamente.',
    // Generic fallback for a terminal Turnstile widget failure (blocked after
    // MAX_ERROR_RETRIES) — a different state than rate-limiting, kept as its own key
    // even though the copy currently matches GENERIC_ERROR.
    CAPTCHA_ERROR: 'Ocorreu um erro. Tente novamente.',
    // CORE-1795: shown when the Turnstile widget never got a site key at all
    // (`NEXT_PUBLIC_TURNSTILE_SITE_KEY` missing/empty at build time) — a
    // deploy/config problem, DISTINCT from CAPTCHA_ERROR (Cloudflare-side runtime
    // failure). Same "can't verify you're not a robot" user-facing framing so we
    // don't leak internal config details, but tracked as its own key/status
    // ('unconfigured') so this cause is never confused with the other two.
    CAPTCHA_UNCONFIGURED_ERROR:
      'Não conseguimos validar que você não é um robô. Tente novamente.',
    // CORE-1795: no RATE_LIMITED_ERROR key here. `request_password_recovery` (the
    // mutation these 3 recovery forms call) NEVER returns error_code `rate_limited` —
    // it always responds `success=True` even when throttled, by BE design
    // (anti-enumeration + silent-throttling, Confluence 1987248131 §6.1). Only
    // `change_password_with_recovery` (B2BOrgResetPassword) can signal it — see that
    // page's own i18n locale files.

    B2C_EMAIL_MESSAGE:
      '* Se você é um estudante de administração. [Clique aqui]({{url}})',
    B2B_EMAIL_ACTIVATE_MESSAGE:
      '* Você ainda não ativou sua conta. [Ative aqui]({{url}})',
    B2B_EMAIL_REGISTERED_MESSAGE:
      '* Conta corporativa já registrada. [Iniciar sessão]({{url}})',
    AUTH_VALIDATION_EMAIL_IN_USE: 'O e-mail inserido já está em uso',

    OVERLAY_ERROR_TITLE: 'Opa, algo deu errado',
    OVERLAY_ERROR_BUTTON_TRY_AGAIN_LABEL: 'Tentar de novo',
  },
};
